<template>
  <div>
    <loading v-bind:active.sync="loading"></loading>
    <image-modal ref="imageModal" v-bind:photos="selectedAttachments"></image-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-1">
        </div>
        <div class="col-2">
          <h6>Date</h6>
        </div>
        <div class="col-2">
          <h6>Service</h6>
        </div>
        <div class="col-2">
          <h6>Type</h6>
        </div>
        <div class="col-2">
          <h6>Vendor</h6>
        </div>
        <div class="col-1">
          <h6>Price</h6>
        </div>
        <div class="col-1">
        </div>
        <div class="col-1">
        </div>
      </div>
      <div class="row" v-for="(homfax, index) in homfaxToDisplay" v-bind:key="homfax.timestamp + index" v-on:click="editHomfax(homfax)">
        <div class="col-1">
          <i v-if="showDelete" class="fa fa-trash" v-on:click.stop="deleteHomFAX((homfax.property_id + ',' + homfax.timestamp))"></i>
        </div>
        <div class="col-2">
          <p>{{ formatDate(homfax.timestamp) }}</p>
        </div>
        <div class="col-2">
          <p>{{ homfax.category }}</p>
        </div>
        <div class="col-2">
          <p>{{ homfax.service }}</p>
        </div>
        <div class="col-2">
          <p>{{ homfax.service_provider_name }}</p>
        </div>
        <div class="col-1">
          <p>${{ homfax.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
        </div>
        <div class="col-1">
          <div class="note-wrapper">
            <i v-if="homfax.notes" class="fa fa-sticky-note"></i>
            <div class="note-content">
              <p class="no-margin">{{ homfax.notes }}</p>
            </div>
          </div>
        </div>
        <div class="col-1">
          <i v-if="homfax.attachments" class="fa fa-paperclip" v-on:click.stop="displayAttachments(homfax.attachments)"></i>
        </div>
      </div>
      <div class="row" v-if="moreToDisplay">
        <div class="col text-center">
          <p v-on:click="loadMoreHomfax" class="link-text">See More</p>
        </div>
      </div>
      <div v-if="homfaxRecords.length" class="row button-padding">
        <div class="col-4 offset-2">
          <button class="btn btn-primary" v-on:click="addHomfax()">Add HomFAX</button>
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" v-on:click="showDelete = !showDelete">Delete HomFAX</button>
        </div>
      </div>
      <div v-else class="row button-padding">
        <div class="col-4 offset-4">
          <button class="btn btn-primary" v-on:click="addHomfax()">Add HomFAX</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageModal from '../ImageModal.vue'
import Loading from 'vue-loading-overlay'
import S3 from 'aws-sdk/clients/s3'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      loading: false,
      numberHomfaxToDisplay: 5,
      selectedAttachments: [],
      showDelete: false
    }
  },
  components: {
    ImageModal,
    Loading
  },
  props: {
    homfaxRecords: Array,
    moreRecordsToLoad: Boolean
  },
  computed: {
    homfaxToDisplay () {
      return this.homfaxRecords.slice(0, this.numberHomfaxToDisplay)
    },
    moreToDisplay () {
      return (this.recordsExceedDisplayed || this.moreRecordsToLoad)
    },
    recordsExceedDisplayed () {
      return this.homfaxRecords.length > this.numberHomfaxToDisplay
    }
  },
  methods: {
    displayAttachments (attachments) {
      let s3 = new S3()
      let signedAttachments = []
      attachments.forEach((photoName) => {
        let params = {
          Bucket: window.CONFIG.HomFaxAttachmentsBucketName,
          Key: photoName,
          Expires: 30
        }
        let signedUrl = s3.getSignedUrl('getObject', params)
        signedAttachments.push(signedUrl)
      })
      this.selectedAttachments = signedAttachments
      this.$refs.imageModal.$refs.imageModal.show()
      this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    },
    addHomfax () {
      this.$emit('showHomfaxModal')
    },
    async deleteHomFAX (idTuple) {
      this.loading = true
      try {
        var client = this.$store.getters.getHomFaxApigClientFactory
        var body = {
          'homfax_keys': [idTuple]
        }
        var params = {}
        var pathTemplate = '/homfax'
        var method = 'DELETE'
        var additionalParams = {}
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.$emit('newHomfaxReceipt', true)
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    editHomfax (homfax) {
      this.$emit('showHomfaxModal', homfax)
    },
    formatDate (timestamp) {
      let dateComponents = timestamp.split(/\D/)
      return dateComponents[1] + '/' + dateComponents[2] + '/' + dateComponents[0]
    },
    loadMoreHomfax () {
      this.numberHomfaxToDisplay += 5
      if (!this.recordsExceedDisplayed && this.moreRecordsToLoad) this.$emit('loadMoreHomfaxRecords')
    }
  }
}
</script>

<style scoped>
.btn-secondary {
  width: 100%;
}

.button-padding {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.fa-paperclip {
  transform: rotate(-45deg);
  vertical-align: bottom;
}

.fa-trash {
  cursor: pointer;
}

.link-text {
  color: #2871d1 !important;
  cursor: pointer;
  margin-top: 0rem;
  margin-bottom: 1rem;
}

.no-margin {
  margin: 0;
}

.note-wrapper {
  position: relative;
}

.note-content {
  background-color: #fff;
  border: solid;
  border-width: thin;
  color: black;
  display: none;
  font-weight: normal;
  position: absolute;
  padding: 0.5em;
  z-index: 1;
  width: 1000%;
}

.note-wrapper:hover .note-content {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/HomFAXReceipts.vue